<template>
  <div class="flowForm">
    <component :is="businessForm"  ref="businessForm" class="create" :list="floderData" @tableshow="tableshow"/>
    <el-table v-if="floderData.length > 0" :data="floderData" :show-header="false" max-height="200px" class="check">
      <el-table-column label="名称" prop="name">
        <template slot-scope="scope">
          <div style="width: 100%; display: flex; align-items: center">
            <img v-if="scope.row.isFolder != 1" :src="className(scope.row)" class="img" alt="" />
            <span style="width: 80%;cursor: pointer;" @click="preview(scope.row)">{{ scope.row.fileName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="120px">
        <template slot-scope="scope">
          <span style="width: 100%; display: flex; justify-content: flex-start">
            <i class="el-icon-download" title="下载" style="margin-right: 15px; color: #5584ff"
              @click="uploadRowType(scope.$index, floderData)" />
            <i class="el-icon-delete" title="删除" style="color: #f54f45"
              @click="deleteRow(scope.$index, floderData)" />
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div class="check">
      <el-button size="small" type="primary" @click="queryApproveNodes"> 查询处理人设置 </el-button>
      <el-button size="small" plain type="primary" @click="queryflow"> 查询流程图 </el-button>
    </div>
    <!-- 处理人 -->
    <div v-if="personSetBoolean" class="nextProcess">
      <flowNodesEditor ref="flowNodes" />
    </div>
    <!-- 流程图 -->
    <div v-if="flowBoolean" class="nextProcess">
      <flowEditorLeftView ref="flowEditorLeftView" :read-only="true" />
    </div>
  </div>
</template>

<script>
import flowNodesEditor from '@/CommonDP/pages/components/launchFlow/components/flowNodesEditor.vue';
import flowEditorLeftView from '@/CommonDP/pages/components/launchFlow/components/flowEditorLeftView.vue';
import flowService from "@/CommonDP/service/flow-service";
import xtDesign from '@/CommonDP/service/integratedModel-service';
import { tableRowIcon } from '@/CommonDP/utils/docPublic';
import { downloadFile, downloadUrltoken } from '@/CommonDP/utils';
import { noLabelFilePreview } from '@/CommonDP/utils/docPublic';
import xunshi from './modules/xunshi.vue'  //巡视
import pangzhan from './modules/pangzhan.vue' // 旁站
import parallel from './modules/parallel.vue'  // 平行检验
import inspect from './modules/inspect.vue'   //检验批验收
import material from './modules/material.vue' //物资进场验收
import aqxj_pz from "./modules/aqxj_pz.vue";
import aqxj_zjc from "./modules/aqxj_zjc.vue";
import aqxj_aqys from "./modules/aqxj_aqys.vue";
import aqxj_aqxs from "./modules/aqxj_aqxs.vue";
import blankFlowForm from '@/CommonDP/pages/components/launchFlow/modules/blankFlowForm.vue';
import { mapState } from 'vuex';
const FORMDATA = () => ({
  qualityName: '', // 流程名称
  endDate: '', // 日期
  modelId: '', // 构件id
});
export default {
  components:{flowNodesEditor,flowEditorLeftView,xunshi,pangzhan,parallel,inspect,material,aqxj_pz,aqxj_zjc,aqxj_aqys,aqxj_aqxs,blankFlowForm},
  data(){
    return{
      floderData:[],
      personSetBoolean: false,
      flowBoolean: false,
      businessForm: '', // 动态组件
      fapi: null,
      loading: false,
      formData: FORMDATA(),
      isbtn: false,
      fileInfoList:[],
      dateDay:''
    }
  },
  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      floderObj: (state) => state.uploaderLocal.floderObj,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      routerParams: (state) => state.projectMg.routerParams,
      userInfo: (state) => state.user.userInfo
    }),
    makeSubmitParam() {
      const json = this.$refs.businessForm.getFormData();
      json.fileInfoList = this.floderData;
      json.endDate=json.endDate?json.endDate:this.dateDay;
      return {
        flowInstanceId: this.routerParams.flowInstanceId || "",
        flowDefinitionId: this.routerParams.flowDefinitionId,
        prjId: this.prjInfo.prjId,
        enterpriseId: this.enterpriseId,
        flowNodeDtoList:this.$refs.flowNodes.getFlowNodeWithAddedUsers(),
        json: json
      }
    },
     mapComponentName() {
      if (this.routerParams.flowKey) {
         if (this.routerParams.flowKey === "xunshi") {
          return "xunshi"
        }else if (this.routerParams.flowKey === "pangzhan") {
          return "pangzhan"
        }else if (this.routerParams.flowKey === "parallel") {
          return "parallel"
        }else if (this.routerParams.flowKey === "inspect") {
          return "inspect"
        }else if (this.routerParams.flowKey === "material") {
          return "material"
        }else if (this.routerParams.flowKey === "aqxj_pz") {
          return "aqxj_pz"
        }else if (this.routerParams.flowKey === "aqxj_zjc") {
          return "aqxj_zjc"
        }else if (this.routerParams.flowKey === "aqxj_aqys") {
          return "aqxj_aqys"
        }else if (this.routerParams.flowKey === "aqxj_aqxs") {
          return "aqxj_aqxs"
        } else {
          return 'blankFlowForm'
        }
      } else {
        return 'blankFlowForm'
      }
    },
  },
  watch: {
    floderObj(newValue, oldValue) {
      if (newValue.fileId) {
        this.floderData.push(newValue);
      } else{
        this.floderData = [];
      }
    }
  },
  mounted() {
    this.getInit()
  },
  
  methods:{
    getForm(){
      return this.makeSubmitParam
    },
    getInit() {
      this.isbtn = false
      this.$emit("isLaunchBtn",this.isbtn)
      this.businessForm = this.mapComponentName;
      this.initData()
    },
    initData() {
      //获取当前时间
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;
      var date = now.getDate();
      month = month < 10 ? "0" + month : month;
      date = date < 10 ? "0" + date : date;
      this.dateDay = year.toString() + "-" + month.toString() + "-" + date.toString() ;
    },
    className(row) {
      return tableRowIcon(row);
    },
    tableshow(val) {
      const arr1 = val;
      const arr2 = this.floderData;
      const arr1fileNames = new Set(arr1.map(({ fileName }) => fileName));
      const isfloderData = [
        ...arr1,
        ...arr2.filter(({ fileName }) => !arr1fileNames.has(fileName))
      ];
      const isnotfloderData = [
        ...arr2.filter(({ fileName }) => arr1fileNames.has(fileName))
      ];
      this.floderData = isfloderData;
      for (const key in isnotfloderData) {
        setTimeout(() => {
          this.$message.warning(
            `${isnotfloderData[key].fileName}上传失败，已存在同名文件`
          );
        }, 10);
      }
    },
    // 查询处理人设置
    async queryApproveNodes() {
      
      if (!this.$refs.businessForm.validateFormData())return;
      this.flowBoolean = false;
      this.personSetBoolean = true;
      this.getNodeData()
    },
    async getNodeData() {
      this.isbtn = true;
      this.$emit("isLaunchBtn",this.isbtn)
      const nodeParams = this.$refs.businessForm.getFormData();
      const queryParam = {
        flowDefinitionVersionId: this.routerParams.currentVersionId,
        enterpriseId: this.enterpriseId,
        prjId: this.prjInfo.prjId,
        param: nodeParams
      };
      const res = await flowService.queryFlowNodeList(queryParam);
      this.$refs.flowNodes.setNodeList(res.data || []);
    },
    // 查询流程图
    async queryflow() {
      this.isbtn = false
      this.$emit("isLaunchBtn",this.isbtn)
      this.flowBoolean = true;
      this.personSetBoolean = false;
      await this.$nextTick()
      this.$refs.flowEditorLeftView.showView(this.routerParams.flowDefinitionId);
    },
    uploadRowType(index, row) {
      const prjId = this.prjInfo.prjId;
      const fileId = row[index].fileId;
      const fileUrl = downloadUrltoken(prjId, fileId);
      downloadFile(fileUrl);
    },
    deleteRow(index) {
      const res = new Map();
      this.floderData = this.floderData.filter(
        (a) => !res.has(a.fileName) && res.set(a.fileName, 1)
      );
      this.floderData.splice(index, 1);
    },
     // 接口：设置表单数据
    setFormData(formData) {
      this.floderData = formData||[];
      
      this.$forceUpdate(); // 调用此函数方法
    },
    async preview(row){
      const {prjId} = this.prjInfo;
       // 获取当前项目的名称
      const prjList = await this.getprjList();
      const prjName = prjList.filter((item) => { 
        if (item.prjId === prjId) return item.prjName; 
      })[0]?.prjName;
      const value = {
        folderId: row.fileId,
        folderName: row.fileName,
        parentId: row.parentId,
        fileVersion: row.versionIds,
        fileType: row.fileType,
        status: row.status
      };
      noLabelFilePreview(value, prjId, prjName, 'ct', 'yes');
    },
    async getprjList() {
      const param = {
        enterpriseId: this.enterpriseId
      };
      const res = await xtDesign.queryPrj(param);
      const prjList = res.data;
      return prjList;
    },
  }
}
</script>

<style lang="scss" scoped>
.flowForm{
  background: #fff;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px 0;
  .create {
    padding: 0 10px;
  }
  .check{
    padding: 5px 20px;
  }
}
</style>